import { Box, Typography, makeStyles } from "@material-ui/core";
import { React, useState } from "react";
import { useParams } from "react-router-dom";
import EditIcon from "@material-ui/icons/Edit";

import ProfileSideInformation from "./ProfileSideInformation";
import EditPersonalProfile from "./potential-profiles-widgets/EditPersonalInformation";
import EditSecondPersonalProfile from "./potential-profiles-widgets/EditSecondPersonalInformation";
import EditContactInformation from "./potential-profiles-widgets/EditContactInformation";
import SfBreadcrumbs from "../../../components/SfBreadcrumbs";
import useOnePotential from "../../../hooks/useOnePotential";
import { Error, Loading } from "ra-ui-materialui";
import {
  calculateAge,
  converttoPhoneFormat,
  getLocalDate,
  guessGender,
} from "../../../utils";
import useEditPotential from "../../../hooks/useEditPotential";
import useOccupations from "../../../hooks/useOccupations";
import useAddressInfo from "../../../hooks/useAddressInfo";
import { usePopup } from "react-hook-popup";
import SimplePopupDialog from "../../../components/SimplePopupDialog";
import SimpleLayoutContainer from "../../../components/SimpleLayoutContainer";
import { useTranslate } from "react-admin";
import useCheckPermissionHook from "../../../hooks/useCheckPermissionHook";
const useStyles = makeStyles((theme) => ({
  container: {
    backgroundColor: theme.lightGray2,
    display: "flex",
    height: "100%",
    width: "100%",
    margin: 0,
  },
  gridLayout: {
    display: "grid",
    gridTemplateColumns: "165px auto 20px",
    rowGap: 3,
  },
  leftSideContainer: {
    width: "70%",
    margin: "30px auto 0",
    paddingLeft: 10,
    boxSizing: "border-box",
  },
  contaienrPersonal: {
    margin: "0 20px 20px 0px",
    borderRadius: 12,
    backgroundColor: theme.white,
    boxSizing: "border-box",
    padding: "10px 20px",
  },
  containerContact: {
    margin: "0 20px 20px 0px",
    boxSizing: "border-box",
    padding: "10px 20px",
    borderRadius: 12,
    backgroundColor: theme.white,
  },
  containerReferal: {
    margin: "0 20px 20px",
    height: 82,
    borderRadius: 12,
    backgroundColor: theme.white,
    justifyContent: "space-evenly",
  },

  textStyle: {
    fontSize: "16px",
    lineHeight: 2,
    color: theme.darkGray,
  },

  editIcon: {
    color: theme.potentialBlue,
  },
}));

function CustomerInsightPagePotentialProfiles() {
  const { id } = useParams();
  const { potential, loading, error } = useOnePotential(id);
  const [showPopup] = usePopup("success", ({ message, handleClose }) => (
    <SimplePopupDialog
      message={message?.message}
      title={message?.title}
      handleClose={handleClose}
      onConfirm={message?.onConfirm}
    />
  ));

  const [showAlert] = usePopup("alert", ({ message, handleClose }) => (
    <SimplePopupDialog
      message={message?.message}
      title={message?.title}
      handleClose={handleClose}
      error={true}
    />
  ));
  const {
    subDistricts,
    districts,
    provinces,
    postcodes,
    loading: addressLoading,
    getSubDistrict,
    getDistrict,
    getProvince,
    getPostcode,
  } = useAddressInfo();
  const classes = useStyles();
  const translate = useTranslate();
  const [editPersonalProfile, setEditPersonalProfileEdit] = useState(false);
  const [editSecondPersonalProfile, setEditSecondPersonalProfileEdit] =
    useState(false);
  const [editContact, setEditContact] = useState(false);
  const [, setEditRefer] = useState(false);
  const { editPotential } = useEditPotential();
  const { loading: permissionLoading, allow } = useCheckPermissionHook({
    code: "Page.Merchant.Customer_Insight",
    write: true,
  });
  const {
    occupations,
    loading: occupationLoading,
    getOccupationName,
    getOccupationfromId,
  } = useOccupations();

  if (loading) return <Loading />;
  if (error) return <Error />;
  const userProfileData = {
    firstName: potential.firstname,
    lastName: potential.lastname,
    nickName: potential.nickname,
    email: potential.email,
    phoneNumber: converttoPhoneFormat(potential.phone),
    address: potential.address,
    subDistrictId: potential.subdistrict_id,
    districtId: potential.district_id,
    provinceId: potential.province_id,
    postcodeId: potential.postcode_id,
    birthday: potential.birthdate,
    age: potential.birthdate ? calculateAge(new Date(potential.birthdate)) : "",
    nationality: potential.nationality,
    gender: potential.gender,
    status: potential.state,
    occupation: potential.occupation_id,
    recommendType: "Friends",
    referFriend: "P'Champ",
    leadName: "Sommai B.",
    imageUrl: potential.image_url,
    version: potential.__v,
    id: potential.id,
  };

  const handleEditing = (index, isEdit) => {
    if (index === 1) {
      setEditPersonalProfileEdit(isEdit);
    } else if (index === 2) {
      setEditSecondPersonalProfileEdit(isEdit);
    } else if (index === 3) {
      setEditContact(isEdit);
    } else if (index === 4) {
      setEditRefer(isEdit);
    } else {
      return;
    }
  };

  const handleOnSave = async (data) => {
    //May call editPotential here?

    try {
      const result = await editPotential({
        id,
        ...potential,
        ...data,
      });
      if (!result.error) {
        return showPopup({
          title: "Success",
          message: "Update successfully",
          onConfirm: () => {
            window.location.reload();
          },
        });
      }
      return showAlert({ title: "Error", message: result.message });
    } catch (error) {
      showAlert({ title: "Error", message: "Something went wrong" });
    }
    // return window.location.reload(false);
  };
  if (permissionLoading) return null;
  return (
    <SimpleLayoutContainer>
      <Box className={classes.container}>
        <Box className={classes.leftSideContainer}>
          <SfBreadcrumbs path="Customer Insight/Potential/Profile" />
          <Typography align="center" variant="h4">
            {translate("ra.text.ci.profile")}
          </Typography>
          <Box>
            <Typography>
              {translate("ra.text.ci.generalInformation.personasInformation")}
            </Typography>
            {editPersonalProfile ? (
              <EditPersonalProfile
                userProfileData={userProfileData}
                onSave={(data) => {
                  handleOnSave(data);
                }}
                onCancel={() => handleEditing(1, false)}
              />
            ) : (
              <Box className={classes.contaienrPersonal}>
                <Box className={classes.gridLayout}>
                  <Typography className={classes.textStyle}>
                    {translate("ra.text.ci.generalInformation.fullName")}
                  </Typography>

                  <Typography className={classes.textStyle}>
                    {userProfileData.firstName + " " + userProfileData.lastName}{" "}
                    ({userProfileData.nickName})
                  </Typography>

                  <Box display="flex">
                    {allow && (
                      <EditIcon
                        className={classes.editIcon}
                        onClick={() => {
                          handleEditing(1, true);
                        }}
                      />
                    )}
                  </Box>
                </Box>

                <Box className={classes.gridLayout}>
                  <Typography className={classes.textStyle}>
                    {translate("ra.text.ci.generalInformation.birthday")}
                  </Typography>

                  <Typography className={classes.textStyle}>
                    {userProfileData.birthday
                      ? getLocalDate(userProfileData.birthday)
                      : ""}
                  </Typography>
                  <Box />
                </Box>

                <Box className={classes.gridLayout}>
                  <Typography className={classes.textStyle}>
                    {translate("ra.text.ci.generalInformation.age")}
                  </Typography>
                  <Typography className={classes.textStyle}>
                    {userProfileData.age}
                  </Typography>
                  <Box />
                </Box>
              </Box>
            )}
            {editSecondPersonalProfile ? (
              <EditSecondPersonalProfile
                userProfileData={userProfileData}
                onSave={(data) => {
                  handleOnSave(data);
                }}
                onCancel={() => {
                  handleEditing(2, false);
                }}
                occupations={occupations}
                currentOccupation={getOccupationfromId(
                  userProfileData.occupation
                )}
              />
            ) : (
              <Box className={classes.contaienrPersonal}>
                <Box className={classes.gridLayout}>
                  <Typography className={classes.textStyle}>
                    {translate("ra.text.ci.generalInformation.nationality")}
                  </Typography>

                  <Typography className={classes.textStyle}>
                    {userProfileData.nationality}
                  </Typography>
                  {allow && (
                    <EditIcon
                      onClick={() => handleEditing(2, true)}
                      className={classes.editIcon}
                    />
                  )}
                </Box>

                <Box className={classes.gridLayout}>
                  <Typography className={classes.textStyle}>
                    {translate("ra.text.ci.generalInformation.gender")}
                  </Typography>
                  <Typography className={classes.textStyle}>
                    {guessGender(userProfileData.gender)}
                  </Typography>
                  <Box />
                </Box>
                <Box className={classes.gridLayout}>
                  <Typography className={classes.textStyle}>
                    {translate("ra.text.ci.generalInformation.status")}
                  </Typography>
                  <Typography className={classes.textStyle}>
                    {userProfileData.status}
                  </Typography>
                  <Box />
                </Box>
                <Box className={classes.gridLayout}>
                  <Typography className={classes.textStyle}>
                    {translate("ra.text.ci.generalInformation.occupation")}
                  </Typography>
                  <Typography className={classes.textStyle}>
                    {occupationLoading
                      ? "Loading"
                      : getOccupationName(userProfileData.occupation)}
                  </Typography>

                  <Box />
                </Box>
              </Box>
            )}
          </Box>
          <Typography align="left">
            {" "}
            {translate("ra.text.ci.generalInformation.contact")}
          </Typography>
          {editContact ? (
            <EditContactInformation
              userProfileData={userProfileData}
              onSave={(data) => {
                handleOnSave(data);
              }}
              onCancel={() => {
                handleEditing(3, false);
              }}
              districts={districts}
              subDistricts={subDistricts}
              provinces={provinces}
              postcodes={postcodes}
            />
          ) : (
            <Box className={classes.containerContact}>
              <Box className={classes.gridLayout}>
                <Typography className={classes.textStyle}>
                  {translate("ra.text.ci.generalInformation.phoneNumber")}
                </Typography>

                <Typography className={classes.textStyle}>
                  {userProfileData.phoneNumber}
                </Typography>
                {allow && (
                  <EditIcon
                    onClick={() => handleEditing(3, true)}
                    className={classes.editIcon}
                  />
                )}
              </Box>

              <Box className={classes.gridLayout}>
                <Typography className={classes.textStyle}>
                  {translate("ra.text.ci.generalInformation.email")}
                </Typography>
                <Typography className={classes.textStyle}>
                  {userProfileData.email}
                </Typography>
                <Box />
              </Box>
              <Box className={classes.gridLayout}>
                <Typography className={classes.textStyle}>
                  {translate("ra.text.ci.generalInformation.address")}
                </Typography>
                {addressLoading ? (
                  "Loading"
                ) : (
                  <Typography className={classes.textStyle}>
                    {`${userProfileData.address ?? ""} ${
                      userProfileData.subDistrictId
                        ? getSubDistrict(userProfileData.subDistrictId)
                        : ""
                    }
                 ${
                   userProfileData.districtId
                     ? getDistrict(userProfileData.districtId)
                     : ""
                 }
                  ${
                    userProfileData.provinceId
                      ? getProvince(userProfileData.provinceId)
                      : ""
                  }
                   ${
                     userProfileData.postcodeId
                       ? getPostcode(userProfileData.postcodeId)
                       : ""
                   }`}
                    {}
                  </Typography>
                )}

                <Box />
              </Box>
            </Box>
          )}
        </Box>
        <ProfileSideInformation userProfileData={userProfileData} />
      </Box>
    </SimpleLayoutContainer>
  );
}

export default CustomerInsightPagePotentialProfiles;
